import $ from 'jquery';

export const zeroPad = (num, places) => {
    return String(num).padStart(places, "0");
}

// Bug fixed 2026-09-18: an invoice's Order Date picked far from today's date
// went straight into Firestore with no second look. Several drafts ended up
// a year (once two years) away from the work they actually billed - hard to
// notice at a glance because day/month still looked right, and worse because
// nothing else in the app re-checks that field once it is saved. This is the
// threshold used to ask "are you sure?" before accepting a date like that.
export const ORDER_DATE_CONFIRM_THRESHOLD_DAYS = 120;

/**
 * Is this Order Date suspiciously far from today? Used to gate an "are you
 * sure?" prompt in the invoice edit screen, not to block the save outright -
 * legitimate backdated corrections do happen, just rarely more than ~4 months.
 */
export const isOrderDateFarFromToday = (dateMs, now = Date.now()) => {
    if (dateMs === null || dateMs === undefined || Number.isNaN(dateMs)) return false;
    const diffDays = Math.abs(now - dateMs) / (1000 * 60 * 60 * 24);
    return diffDays > ORDER_DATE_CONFIRM_THRESHOLD_DAYS;
}

// Never fire more queries / return more rows than this for a single search.
export const NUMBER_SEARCH_MAX_PREFIXES = 30;
export const NUMBER_SEARCH_MAX_RESULTS = 200;

/**
 * Expands what the user typed into the list of Firestore prefixes to look up.
 *
 * Firestore has no "contains", only prefix ranges, so a partial number is
 * turned into every plausible prefix and the results are merged:
 *
 *   "1/0426" -> ["1/0426"]                       (the exact invoice)
 *   "1/42"   -> ["1/42", "1/0042"]               (42xx AND 0042)
 *   "426"    -> ["1/426","1/0426", ... per serie, "426/"]
 *   "11"     -> [... per serie ..., "11/"]       (also the whole serie 11)
 *   "2/#178" -> ["#178"]                          (drafts: the serie is printed
 *                                                  by the list, not stored)
 */
export const buildNumberSearchPrefixes = (rawTerm, serieIds) => {
    const term = String(rawTerm === undefined || rawTerm === null ? "" : rawTerm).trim();
    if (!term) return [];
    const series = Array.isArray(serieIds) ? serieIds.map(String) : [];
    const out = [];

    // Drafts are stored as "#timestamp"; the list prints them as "serie/#timestamp".
    const draft = term.match(/^(?:\d+\/)?(#.+)$/);
    if (draft) return [draft[1]];

    const withSerie = term.match(/^(\d+)\/(\d+)$/);
    if (withSerie) {
        const serie = withSerie[1];
        const seq = withSerie[2];
        out.push(serie + "/" + seq);
        if (seq.length < 4) out.push(serie + "/" + zeroPad(seq, 4));
    } else if (/^\d+$/.test(term)) {
        // Digits only: it may be the sequence (in any serie) or a serie itself.
        series.forEach((serie) => {
            out.push(serie + "/" + term);
            if (term.length < 4) out.push(serie + "/" + zeroPad(term, 4));
        });
        out.push(term + "/");
    } else if (/^\d+\/$/.test(term)) {
        out.push(term);
    } else {
        out.push(term);
    }

    return Array.from(new Set(out)).slice(0, NUMBER_SEARCH_MAX_PREFIXES);
}

export const updateValues = (invoice) => {
    const { invoiceList } = invoice;
    let subTotal = 0;
    let taxable = 0;
    invoiceList.forEach((item, index) => {
      const price = item.costs * item.qty;
      invoice.invoiceList[index].price = parseFloat(price).toFixed(2);
      subTotal += price;
      if (!invoice.invoiceList[index].noTaxable) {
        taxable += price;
      }
    });
    invoice.invoiceList = [...invoiceList];
    invoice.taxable = parseFloat(taxable).toFixed(2);
    invoice.subTotal = parseFloat(subTotal).toFixed(2);
    invoice.vatPrice = parseFloat(parseFloat(invoice.vatRate) * parseFloat(taxable) * 0.01).toFixed(2);
    invoice.totalCost = (parseFloat(invoice.vatPrice) + parseFloat(subTotal)).toFixed(2);
    return invoice;
};

export const checkInvoice = (invoice) => {
    const emptyKeys = [
        "number",
        "billTo",
        "billToAddress",
        "billFrom",
        "billFromAddress",
        "currency",
    ];
    const emptyKeysErrors = [
        "Invoice Number",
        "Bill To",
        "Bill To Address",
        "Bill From",
        "Bill From Address",
        "Currency",
    ];
    for (let i = 0; i < emptyKeys.length; i++) {
        if (!invoice[emptyKeys[i]]) {
        return `Please fill in ${emptyKeysErrors[i]}`;
        }
    }
    for (let i = 0; i < invoice.invoiceList.length; i++) {
        if (!invoice.invoiceList[i].itemName) {
        return `Please fill in item name of ${i + 1} item`;
        }
        if (invoice.invoiceList[i].costs === 0) {
        return `cost of ${i + 1} item should be positive`;
        }
        if (invoice.invoiceList[i].qty === 0) {
        return `quantity of ${i + 1} item should be positive`;
        }
    }
    return "";
};

export function initSelectAutoExpand () {
  // Applied globally on all textareas with the "autoExpand" class
  $(document)
  .one('focus.autoExpand', 'textarea.autoExpand', function(){
      var savedValue = this.value;
      this.value = '';
      this.baseScrollHeight = this.scrollHeight;
      this.value = savedValue;
  })
  .on('input.autoExpand', 'textarea.autoExpand', function(){
      var minRows = this.getAttribute('data-min-rows')|0, rows;
      this.rows = minRows;
      rows = Math.ceil((this.scrollHeight - this.baseScrollHeight) / 16);
      this.rows = minRows + rows;
  });
}

export function stringToInt(value, defValue = 0) {
  if (!value) {
    return 0;
  } else if (!isNaN(value)) {
    return parseInt(value, 10);
  }
  return defValue;
}
export function stringToPosetiveInt(value, defValue = 0) {
  const val = stringToInt(value, defValue);
  return val > -1 ? val : defValue;
}

export function stringToFloat(value, defValue = 0) {
  return parseFloat(value).toFixed(2);
}

export function stringToPosetiveFloat(value, defValue = 0) {
  const val = stringToFloat(value, defValue);
  return val > -1 ? val : defValue;
}
